function scrollTo (top, left) {
    setTimeout(() => {
        window.scroll({ top, left, behavior: 'smooth' })
    }, 200)
}

function scroll (hash) {
    const elem = document.getElementById(`${hash}`)
    const scrolltop = elem ? elem.offsetTop - 20 : 0
    scrollTo(scrolltop, 0)
}

function scrollToTop () {
    scrollTo(0, 0)
}

function getHash (str) {
    return str.toLowerCase().replace(/\s+/g, '')
}

function fireHashChange (event, slug, page) {
    if (window.location.pathname.includes(page)) {
        event?.preventDefault()
        window.location.hash = '!' + slug
    }
}

function handleHashChange () {
    const hash = window.location.hash.replace(/#!+/g, '')
    scroll(hash)
}

export {
    getHash,
    fireHashChange,
    handleHashChange,
    scrollToTop
}
